var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconPriceBookInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#A9B1C7",
    width: "20px",
    height: "20px",
    viewBox: "0 0 52 52",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "price-book"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,36.9V29H7a3.22,3.22,0,0,1-3.2-3.2,3.26,3.26,0,0,1,3-3.2H8.6V14.7H7a3.22,3.22,0,0,1-3.2-3.2,3.26,3.26,0,0,1,3-3.2H8.6V6.8a4.79,4.79,0,0,1,4.6-4.6l30,0c2.6,0,4.9,1.65,5,4.15V44.6a5.39,5.39,0,0,1-4.8,5.2h-30A5.26,5.26,0,0,1,8.5,45V43.3H7a3.22,3.22,0,0,1-3.2-3.2,3.26,3.26,0,0,1,3-3.2ZM27.5,13.7a2,2,0,0,0-1.5.6L14.8,25.4a2.05,2.05,0,0,0,0,2.9L27.1,40.6a2.05,2.05,0,0,0,2.9,0L41.2,29.4a2,2,0,0,0,.6-1.5l-.2-6.8a1.68,1.68,0,0,0-.6-1.4l-5.3-5.4a2.25,2.25,0,0,0-1.4-.6ZM23.6,24.5a.48.48,0,0,1,.7,0h0L30.8,31a.48.48,0,0,1,0,.7h0l-1.1,1.1a.48.48,0,0,1-.7,0h0l-6.5-6.5a.48.48,0,0,1,0-.7h0Zm3.2-3a.48.48,0,0,1,.7,0h0L34,28a.48.48,0,0,1,0,.7h0l-1,1a.48.48,0,0,1-.7,0h0l-6.5-6.5a.48.48,0,0,1,0-.7h0Zm10.5-3.3a2.05,2.05,0,1,1-2.9,0A2.05,2.05,0,0,1,37.3,18.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconPriceBookInactive);
export default __webpack_public_path__ + "static/media/menu_icon_price_book_inactive.26b702346986088f8eea9042c8fdf529.svg";
export { ForwardRef as ReactComponent };